export class TranslateTextResponse {
  Successful: boolean = false;
  Message: string = '';
  ObjectTag: TranslateText = new TranslateText();
  // FinancialYearMonthListResponse: FinancialYearMonthListResponse[] = [];
}
export class TranslateText {
  ConvertedText: string = '';
}
